import type { Copy } from "../types";

export const ar: Copy = {
    seo: {
      title: "حاسبة عمر السيارة | فحص عمر المركبة حسب السنة والشهر",
      description:
        "تحقق من العمر الدقيق للمركبة من سنة التصنيع والشهر الاختياري. اعرض السنوات والأشهر والأيام وإجمالي الأيام ومواعيد المعالم في أداة واحدة واضحة.",
      keywords: [
        "حاسبة عمر السيارة",
        "حاسبة عمر المركبة",
        "سنة تصنيع السيارة",
        "شهر تصنيع المركبة",
        "كم عمر سيارتي",
        "فحص عمر المركبة",
        "حاسبة عمر RC",
        "عمر السيارة حسب السنة",
        "عمر السيارة حسب الشهر",
        "حاسبة تاريخ المركبة",
        "بديل mParivahan",
        "بديل Parivahan",
        "حاسبة عمر المركبة RTO",
        "فحص عمر تسجيل السيارة",
        "عمر تسجيل المركبة",
      ],
      faq: [
        {
          question: "ماذا تفعل هذه الحاسبة؟",
          answer:
            "تحسب العمر الدقيق للمركبة من سنة التصنيع المحددة والشهر الاختياري، ثم تعرض السنوات والأشهر والأيام ومعلومات المعالم.",
        },
        {
          question: "لماذا يوجد شهر اختياري؟",
          answer:
            "إضافة الشهر تجعل حساب العمر أكثر دقة. إذا تجاهلت الشهر، يستخدم التطبيق شهر يناير من السنة المحددة.",
        },
        {
          question: "هل يمكنني اختيار سنة أو شهر في المستقبل؟",
          answer:
            "لا. السنوات المستقبلية محظورة، والأشهر المستقبلية معطلة عندما تكون السنة المحددة هي السنة الحالية.",
        },
      ],
    },
    headerTagline: "أداة للمركبات",
    headerTitle: "حاسبة عمر السيارة",
    reset: "إعادة ضبط",
    switchToLight: "التبديل إلى الوضع الفاتح",
    switchToDark: "التبديل إلى الوضع الداكن",
    languageLabel: "اللغة",
    languageEnglish: "الإنجليزية",
    languageHindi: "الهندية",
    heroEyebrow: "عمر السيارة بوضوح",
    heroTitle: "أداة تاريخ نظيفة لعمر المركبة.",
    heroDescription: "اختر سنة التصنيع. أضف الشهر فقط إذا أردت نتيجة أكثر دقة.",
    yearSelectLabel: "سنة التصنيع",
    monthSelectLabel: "شهر التصنيع",
    includeMonthLabel: "تضمين شهر محدد لمزيد من الدقة",
    includeMonthNote: "إذا لم تضف شهرًا، فسيُستخدم يناير في الحساب.",
    yearOnlyBadge: "السنة فقط",
    yearMonthBadge: "السنة + الشهر",
    yearPlaceholder: "اختر السنة",
    monthPlaceholder: "اختر الشهر",
    inputTitle: "سنة التصنيع",
    inputLabel: "سنة التصنيع",
    blockedDateNote: "السنوات المستقبلية محظورة.",
    result: "النتيجة",
    vehicleAgeLead: "مركبتك",
    asOfToday: "حتى اليوم",
    years: "سنوات",
    months: "أشهر",
    days: "أيام",
    totalDays: (count) => `${count.toLocaleString("en-IN")} يومًا إجمالًا`,
    ageLabels: { almostNew: "شبه جديدة", modern: "حديثة", mature: "مخضرمة", classic: "كلاسيكية" },
    estimatedValue: {
      high: "إمكانات إعادة بيع عالية",
      healthy: "احتفاظ جيد بالقيمة",
      moderate: "انخفاض معتدل في القيمة",
      collector: "قد يزداد اهتمام المقتنين",
    },
    maintenanceTitle: "الصيانة",
    maintenance: {
      routine: "صيانة دورية والعناية الأصلية",
      watch: "راقب الفرامل والسوائل والإطارات",
      plan: "خطط لقطع الاستهلاك والفحوصات",
      specialized: "تزداد أهمية الصيانة المتخصصة",
    },
    registrationTitle: "التسجيل",
    registration: {
      collector: "قد تنطبق معاملة المقتنيات في بعض المناطق",
      classic: "قد ينطبق تسجيل السيارات الكلاسيكية في بعض المناطق",
      standard: "توقع التجديدات القياسية والفحوصات الإقليمية",
      regular: "عادةً ينطبق التسجيل العادي",
    },
    upcomingMilestoneTitle: "المعلمة التالية",
    milestoneTimelineTitle: "الجدول الزمني للمعالم",
    milestoneRemaining: ({ label, days }) => `${label} خلال ${days.toLocaleString("ar-EG")} يوم`,
    reached: "متحقق",
    upcoming: "قادم",
    allMilestonesReachedTitle: "تم الوصول إلى جميع المعالم المدرجة",
    allMilestonesReachedBody: "تجاوزت هذه المركبة نطاق المعالم المعروض حاليًا في التطبيق.",
    copySummary: "نسخ الملخص",
    shareResult: "مشاركة النتيجة",
    resetMessage: "تمت إعادة تعيين الحاسبة",
    summaryCopied: "تم نسخ الملخص إلى الحافظة",
    clipboardFailed: "فشل الوصول إلى الحافظة",
    emptyTitle: "اختر سنة التصنيع لعرض التفاصيل الكاملة",
    emptyDescription:
      "ستظهر لك العمر الدقيق، إجمالي الأيام، ملاحظات الصيانة، حالة الكلاسيكية، وتوقيت المعالم بعد اختيار السنة.",
    shareTitle: "حاسبة عمر السيارة",
    summary: ({ label, years, months, days, asOf }) =>
      `تم تصنيع مركبتي في ${label}، وحتى ${asOf} يبلغ عمرها ${years} سنوات و${months} أشهر و${days} أيام.`,
    milestones: {
      1: { label: "السنة الأولى", note: "مفيد لتخطيط الضمان والصيانة." },
      3: { label: "ثلاث سنوات", note: "نقطة شائعة لإعادة البيع وتغيّر القيمة." },
      5: { label: "خمس سنوات", note: "وقت مناسب لوضع ميزانية صيانة أعمق." },
      10: { label: "عشر سنوات", note: "المكونات الأقدم تستحق اهتمامًا إضافيًا." },
      15: { label: "خمسة عشر عامًا", note: "في بعض المناطق يبدأ التعامل الكلاسيكي هنا." },
      25: { label: "خمسة وعشرون عامًا", note: "قد يهم جامعي السيارات وبعض أسواق الاستيراد." },
    },
  };
